import format from 'date-fns/format';
import { NewPermPlacementDetailsGetters } from './new-perm-placement.keys';

export const getInitialState = () => {
  return {
    permPlacement: {
      created_at: format(new Date(), 'YYYY-MM-DD'),
      reference_number: null,
      created_by_id: null,
      created_comment: null,
      status: 'DRAFT',
      branch_name: null,
      division_abbr: null,
      invoice_number: null,
      first_name: null,
      last_name: null,
      occupation: null,
      start_date: null,
      original_start_date: null,
      client_transfer: false,
      client_id: null,
      salary: null,
      finders_percentage: null,
      billing_amount: null,
      outsource_amount: null,
      outsource_person: null,
      gst_on_invoice: false,
      hst_on_invoice: false,
      qst_on_invoice: false,
      currency_code: null,
      guarantee_amount: null,
      guarantee_unit: null,
      guarantee_replacement: null,
      guarantee_other: null,
      payment_terms: null,
      split_description: null,
      split_percentage: null,
      split_dollars: null,
      comments: null,
      billing_method_id: null,
      rebate_id: null,
      payment_term_amount: null,
      payment_term_unit: null,
      stakeholderCommissions: []
    }
  };
};
export const newPermPlacementStore = {
  state: getInitialState,
  getters: {
    [NewPermPlacementDetailsGetters.PermPlacement]: state => {
      return state.permPlacement;
    }
  }
};
